var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showNearbyRestaurantAlert)?_c('div',{staticClass:"cmg-nearby-restaurant-alert-container fs-unmask"},[_c('img',{staticClass:"icon",attrs:{"src":_vm.infoIcon}}),_c('div',{staticClass:"nearby-restaurant-alert"},[_vm._v("Make sure you pickup from the right location, there are multiple in this area.")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }